
declare const $;
export function toggleMenu_directive($timeout) {
    "ngInject";

    var directive = {
        link: link,
        restrict: 'A',

    };
    return directive;

    function link(scope, element, attrs) {
        $timeout(() => {

            
            if (!$(element).parent().hasClass('toggled')) {
                $(element).next().hide();
            }
            $(element).on('click', () => {
                $(element).parent().toggleClass('toggled');
                $(element).next().slideToggle(200);
            });
        }, 1)
    }
}


function ControllerController() {

}



// WEBPACK FOOTER //
// ./src/directives/toggleMenu/toggleMenu.ts